module.exports = __webpack_public_path__ + "img/art_5_1.ac029db3.jpg";